module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-embed": "static-1.26002",
      "conversations-internal-schema": "static-1.12547",
      "head-dlb": "static-1.4841",
      "hs-test-utils": "static-1.7843",
      "hubspot-url-utils": "static-1.3993",
      "HubStyleTokens": "static-2.11278",
      "I18n": "static-7.1580",
      "jasmine-runner": "static-1.6307",
      "quartz": "static-1.6780",
      "react": "static-7.181",
      "sinon": "static-1.9",
      "StyleGuideUI": "static-3.484",
      "webpack-env": "static-1.54",
      "visitor-ui-component-library": "static-1.5970",
      "enviro": "static-4.405",
      "hs-promise-rejection-tracking": "static-1.5387",
      "PortalIdParser": "static-2.367",
      "raven": "static-3.5725",
      "raven-hubspot": "static-1.6032",
      "bend-plugin-trellis-migration": "static-1.3265",
      "moment": "static-3.26",
      "customer-data-email": "static-1.17733",
      "cv-backend-services": "static-1.1514",
      "hub-http": "static-1.6054",
      "immutable": "static-2.19",
      "immutable-less": "static-1.4491",
      "quartz-config": "static-1.558",
      "quartz-core": "static-1.5999",
      "transmute": "static-2.85",
      "HeadJS": "static-2.718",
      "react-dom": "static-7.85",
      "foundations-components": "static-1.7595",
      "framer-motion": "static-1.68",
      "hs-test-utils-bend-plugin": "static-1.2954",
      "msw": "static-1.39",
      "react-redux": "static-7.68",
      "redux": "static-4.16",
      "testing-library": "static-1.148",
      "foundations-theming": "static-1.4247",
      "i18n-data": "static-1.217",
      "metrics-js": "static-1.9476",
      "moment-timezone": "static-5.79",
      "react-utils": "static-2.5210",
      "jasmine": "static-4.4163",
      "csstype": "static-1.50",
      "hoist-non-react-statics": "static-3.9",
      "PatternValidationJS": "static-1.437",
      "react-aria": "static-1.62",
      "styled-components": "static-2.86",
      "UIComponents": "static-3.8225",
      "visitor-ui-component-library-icons": "static-1.5781",
      "bender-build-tools": "static-1.2982",
      "apollo-dlb": "static-3.80",
      "apollo-link-hub-http": "static-2.4488",
      "apollo-stack-hubspot": "static-3.82",
      "classnames": "static-2.10",
      "cssUtils": "static-1.744",
      "customer-data-objects": "static-1.7485",
      "customer-data-ui-utilities": "static-1.9661",
      "data-fetching-client": "static-1.9514",
      "FileManagerCore": "static-1.38505",
      "FileManagerLib": "static-1.38646",
      "foundations-assets": "static-1.4676",
      "graphql": "static-1.78",
      "hs-promise-utils": "static-1.5430",
      "hubspot-apollo-client": "static-1.4717",
      "icons": "static-2.626",
      "react-immutable-proptypes": "static-2.8",
      "react-immutable-render-mixin": "static-1.9",
      "react-input-autosize": "static-2.17",
      "react-select-plus": "static-1.65",
      "react-virtualized": "static-2.95",
      "rpc-client-utils": "static-1.4474",
      "salesImages": "static-1.521",
      "timezone-utils": "static-2.5081",
      "ui-gdpr-components": "static-1.10184",
      "ts-schema": "static-1.3941",
      "hs-lodash": "static-4.45",
      "immer": "static-1.33",
      "dispatcher": "static-1.133",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.803",
      "hubspotter-http": "static-1.4514",
      "mobile-manifest-mixins": "static-1.491",
      "module-federation": "static-1.19",
      "quartz-auth": "static-1.455",
      "quartz-head": "static-1.445",
      "quartz-i18n": "static-1.455",
      "quartz-routing": "static-1.210",
      "quartz-test": "static-1.455",
      "quartz-tracking": "static-1.159",
      "quick-fetch": "static-1.3773",
      "react-rhumb": "static-1.16488",
      "ui-fonts": "static-1.540",
      "usage-tracker-container": "static-1.7162",
      "usage-tracker-core": "static-1.7022",
      "bend-plugin-foundations-components": "static-1.3864",
      "floating-ui": "static-1.52",
      "foundations-theming-specialty": "static-1.1963",
      "hs-story-utils": "static-1.9263",
      "tanstack-table": "static-1.51",
      "trellis-assets": "static-1.1312",
      "ui-images": "static-2.1106",
      "bend-plugin-foundations-theming": "static-1.2730",
      "foundations-theming-base": "static-1.3232",
      "stylex": "static-1.28",
      "HubStyle": "static-2.11586",
      "sassPrefix": "static-1.152",
      "inbound-db-properties-service-client": "static-1.3710",
      "property-translator": "static-1.5245",
      "react-dnd-compat": "static-1.4457",
      "fast-json-stable-stringify": "static-1.4",
      "ai-components-ui-library": "static-1.8454",
      "audio-components": "static-1.5667",
      "cropperjs": "static-1.10",
      "file-manager-components": "static-1.23006",
      "FileManagerImages": "static-1.36157",
      "foundations-components-legacy": "static-1.620",
      "immerable": "static-1.3991",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "ui-universal-auth": "static-1.8753",
      "urlinator": "static-1.4368",
      "video-components": "static-1.12683",
      "video-data-lib": "static-1.34338",
      "video-embed": "static-1.35172",
      "redux-thunk": "static-2.43",
      "hubspot-apollo-cache": "static-1.176",
      "hub-http-shared-msw-handlers": "static-1.9562",
      "hubspotter-http-shared-msw-handlers": "static-1.9560",
      "history": "static-4.47",
      "react-router-dom": "static-5.26",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "autolinker": "static-3.11",
      "chatspot-core": "static-1.20482",
      "chirp-fetch": "static-1.1719",
      "ContentUtils": "static-1.67731",
      "copilot-toolkit": "static-1.10627",
      "sanitize": "static-1.4311",
      "sanitize-text": "static-1.7982",
      "content-assistance-lib": "static-1.7503",
      "usage-tracker": "static-1.7172",
      "ui-addon-iframeable": "static-1.8884",
      "video-components-external": "static-1.10680",
      "unified-auth-core-lib": "static-1.548",
      "content-icons-ui": "static-1.2167",
      "social-insights-client-types": "static-1.21467",
      "SharedI18nStrings": "static-1.180",
      "outpost": "static-1.4038",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4644",
      "integrations-lib": "static-1.15551",
      "underscore": "static-1.8",
      "magpie-lib": "static-1.5431",
      "magpie-types": "static-1.4891",
      "simple-logging-lib": "static-1.2887",
      "superstore": "static-1.4606",
      "ui-addon-video-player": "static-1.8533",
      "ui-coaching-tips": "static-1.28044",
      "navigation-messaging": "static-1.6726",
      "content-media-composition-data-lib": "static-1.11586",
      "content-media-compositions": "static-2.15593",
      "idb-keyval": "static-1.40",
      "media-bridge-lib": "static-1.18628",
      "fsm": "static-1.3567",
      "flux-actions": "static-1.311",
      "frontend-preferences-client": "static-1.7761",
      "integrations-error-boundary-lib": "static-1.12966",
      "integrations-tracking-lib": "static-1.5425",
      "laboratory-lib": "static-3.6996",
      "native-integrations-shared-strings": "static-1.7625",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10210",
      "rxjs": "static-5.10",
      "ui-addon-i18n": "static-1.10981",
      "ui-shepherd-react": "static-3.9983",
      "reactive-lib": "static-1.562",
      "growth-onboarding-feedback-components": "static-1.6418",
      "hls.js": "static-1.35",
      "js-cookie": "static-1.18",
      "universal-page-editor-lib": "static-1.2835",
      "foundations-components-test-utils": "static-1.5078",
      "react-dlb": "static-1.73",
      "crm-record-cards-service-types": "static-1.3479",
      "framework-data-schema-resolvers": "static-1.6709",
      "location-customization-utils-lib": "static-1.8679",
      "batch-promise": "static-1.1388",
      "conditional-properties-service-client": "static-1.3659",
      "crm-pipelines-api-client-types": "static-1.4001",
      "framework-builder-read-service-client": "static-1.3869",
      "framework-data-schema-quick-fetch": "static-1.6614",
      "inbound-db-meta-service-client": "static-1.3456",
      "multi-currency-client-types": "static-1.3552",
      "persist-promise": "static-1.3545"
    },
    "depPathPrefixes": {
      "conversations-embed": "/conversations-embed/static-1.26002",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12547",
      "head-dlb": "/head-dlb/static-1.4841",
      "hs-test-utils": "/hs-test-utils/static-1.7843",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3993",
      "HubStyleTokens": "/HubStyleTokens/static-2.11278",
      "I18n": "/I18n/static-7.1580",
      "jasmine-runner": "/jasmine-runner/static-1.6307",
      "quartz": "/quartz/static-1.6780",
      "react": "/react/static-7.181",
      "sinon": "/sinon/static-1.9",
      "StyleGuideUI": "/StyleGuideUI/static-3.484",
      "webpack-env": "/webpack-env/static-1.54",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5970",
      "enviro": "/enviro/static-4.405",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5387",
      "PortalIdParser": "/PortalIdParser/static-2.367",
      "raven": "/raven/static-3.5725",
      "raven-hubspot": "/raven-hubspot/static-1.6032",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3265",
      "moment": "/moment/static-3.26",
      "customer-data-email": "/customer-data-email/static-1.17733",
      "cv-backend-services": "/cv-backend-services/static-1.1514",
      "hub-http": "/hub-http/static-1.6054",
      "immutable": "/immutable/static-2.19",
      "immutable-less": "/immutable-less/static-1.4491",
      "quartz-config": "/quartz-config/static-1.558",
      "quartz-core": "/quartz-core/static-1.5999",
      "transmute": "/transmute/static-2.85",
      "HeadJS": "/HeadJS/static-2.718",
      "react-dom": "/react-dom/static-7.85",
      "foundations-components": "/foundations-components/static-1.7595",
      "framer-motion": "/framer-motion/static-1.68",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2954",
      "msw": "/msw/static-1.39",
      "react-redux": "/react-redux/static-7.68",
      "redux": "/redux/static-4.16",
      "testing-library": "/testing-library/static-1.148",
      "foundations-theming": "/foundations-theming/static-1.4247",
      "i18n-data": "/i18n-data/static-1.217",
      "metrics-js": "/metrics-js/static-1.9476",
      "moment-timezone": "/moment-timezone/static-5.79",
      "react-utils": "/react-utils/static-2.5210",
      "jasmine": "/jasmine/static-4.4163",
      "csstype": "/csstype/static-1.50",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "react-aria": "/react-aria/static-1.62",
      "styled-components": "/styled-components/static-2.86",
      "UIComponents": "/UIComponents/static-3.8225",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5781",
      "bender-build-tools": "/bender-build-tools/static-1.2982",
      "apollo-dlb": "/apollo-dlb/static-3.80",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4488",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.82",
      "classnames": "/classnames/static-2.10",
      "cssUtils": "/cssUtils/static-1.744",
      "customer-data-objects": "/customer-data-objects/static-1.7485",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9661",
      "data-fetching-client": "/data-fetching-client/static-1.9514",
      "FileManagerCore": "/FileManagerCore/static-1.38505",
      "FileManagerLib": "/FileManagerLib/static-1.38646",
      "foundations-assets": "/foundations-assets/static-1.4676",
      "graphql": "/graphql/static-1.78",
      "hs-promise-utils": "/hs-promise-utils/static-1.5430",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4717",
      "icons": "/icons/static-2.626",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-virtualized": "/react-virtualized/static-2.95",
      "rpc-client-utils": "/rpc-client-utils/static-1.4474",
      "salesImages": "/salesImages/static-1.521",
      "timezone-utils": "/timezone-utils/static-2.5081",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10184",
      "ts-schema": "/ts-schema/static-1.3941",
      "hs-lodash": "/hs-lodash/static-4.45",
      "immer": "/immer/static-1.33",
      "dispatcher": "/dispatcher/static-1.133",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.803",
      "hubspotter-http": "/hubspotter-http/static-1.4514",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.491",
      "module-federation": "/module-federation/static-1.19",
      "quartz-auth": "/quartz-auth/static-1.455",
      "quartz-head": "/quartz-head/static-1.445",
      "quartz-i18n": "/quartz-i18n/static-1.455",
      "quartz-routing": "/quartz-routing/static-1.210",
      "quartz-test": "/quartz-test/static-1.455",
      "quartz-tracking": "/quartz-tracking/static-1.159",
      "quick-fetch": "/quick-fetch/static-1.3773",
      "react-rhumb": "/react-rhumb/static-1.16488",
      "ui-fonts": "/ui-fonts/static-1.540",
      "usage-tracker-container": "/usage-tracker-container/static-1.7162",
      "usage-tracker-core": "/usage-tracker-core/static-1.7022",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3864",
      "floating-ui": "/floating-ui/static-1.52",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1963",
      "hs-story-utils": "/hs-story-utils/static-1.9263",
      "tanstack-table": "/tanstack-table/static-1.51",
      "trellis-assets": "/trellis-assets/static-1.1312",
      "ui-images": "/ui-images/static-2.1106",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2730",
      "foundations-theming-base": "/foundations-theming-base/static-1.3232",
      "stylex": "/stylex/static-1.28",
      "HubStyle": "/HubStyle/static-2.11586",
      "sassPrefix": "/sassPrefix/static-1.152",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3710",
      "property-translator": "/property-translator/static-1.5245",
      "react-dnd-compat": "/react-dnd-compat/static-1.4457",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.8454",
      "audio-components": "/audio-components/static-1.5667",
      "cropperjs": "/cropperjs/static-1.10",
      "file-manager-components": "/file-manager-components/static-1.23006",
      "FileManagerImages": "/FileManagerImages/static-1.36157",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.620",
      "immerable": "/immerable/static-1.3991",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "ui-universal-auth": "/ui-universal-auth/static-1.8753",
      "urlinator": "/urlinator/static-1.4368",
      "video-components": "/video-components/static-1.12683",
      "video-data-lib": "/video-data-lib/static-1.34338",
      "video-embed": "/video-embed/static-1.35172",
      "redux-thunk": "/redux-thunk/static-2.43",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.176",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9562",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9560",
      "history": "/history/static-4.47",
      "react-router-dom": "/react-router-dom/static-5.26",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "autolinker": "/autolinker/static-3.11",
      "chatspot-core": "/chatspot-core/static-1.20482",
      "chirp-fetch": "/chirp-fetch/static-1.1719",
      "ContentUtils": "/ContentUtils/static-1.67731",
      "copilot-toolkit": "/copilot-toolkit/static-1.10627",
      "sanitize": "/sanitize/static-1.4311",
      "sanitize-text": "/sanitize-text/static-1.7982",
      "content-assistance-lib": "/content-assistance-lib/static-1.7503",
      "usage-tracker": "/usage-tracker/static-1.7172",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8884",
      "video-components-external": "/video-components-external/static-1.10680",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.548",
      "content-icons-ui": "/content-icons-ui/static-1.2167",
      "social-insights-client-types": "/social-insights-client-types/static-1.21467",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
      "outpost": "/outpost/static-1.4038",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4644",
      "integrations-lib": "/integrations-lib/static-1.15551",
      "underscore": "/underscore/static-1.8",
      "magpie-lib": "/magpie-lib/static-1.5431",
      "magpie-types": "/magpie-types/static-1.4891",
      "simple-logging-lib": "/simple-logging-lib/static-1.2887",
      "superstore": "/superstore/static-1.4606",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8533",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.28044",
      "navigation-messaging": "/navigation-messaging/static-1.6726",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11586",
      "content-media-compositions": "/content-media-compositions/static-2.15593",
      "idb-keyval": "/idb-keyval/static-1.40",
      "media-bridge-lib": "/media-bridge-lib/static-1.18628",
      "fsm": "/fsm/static-1.3567",
      "flux-actions": "/flux-actions/static-1.311",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7761",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12966",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5425",
      "laboratory-lib": "/laboratory-lib/static-3.6996",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7625",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10210",
      "rxjs": "/rxjs/static-5.10",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.10981",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.9983",
      "reactive-lib": "/reactive-lib/static-1.562",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6418",
      "hls.js": "/hls.js/static-1.35",
      "js-cookie": "/js-cookie/static-1.18",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2835",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5078",
      "react-dlb": "/react-dlb/static-1.73",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3479",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6709",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8679",
      "batch-promise": "/batch-promise/static-1.1388",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3659",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4001",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3869",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6614",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3456",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3552",
      "persist-promise": "/persist-promise/static-1.3545"
    },
    "bundlingPackage": "conversations-embed",
    "bundlingPackageVersion": "static-1.26002",
    "project": "conversations-embed",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};